import { ChargerIndicatorProps } from '../leaflet-map.types';
import { COLORS } from '../leaflet-map.constants';
import { calculateColorSegments } from './calculateColorSegments';
import { calculateSegmentDashes } from './calculateSegmentDashes';
import { generateCircleSegments } from './generateCircleSegments';

const STROKE_WIDTH = 6;
const SVG_SIZE = 53;
const RADIUS = SVG_SIZE / 2 - STROKE_WIDTH / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const centerPoint = SVG_SIZE / 2;

export function createChargerIndicator({
    unavailableConnectors = 0,
    availableConnectors = 0,
    totalConnectors = 0,
    busyConnectors = 0,
    price = '0.00 $',
    pricingOptionLabel = '',
    isFree = false,
}: ChargerIndicatorProps) {
    const colorSegments = calculateColorSegments({
        unavailableConnectors,
        availableConnectors,
        totalConnectors,
        busyConnectors,
    });

    const segments = calculateSegmentDashes(colorSegments, CIRCUMFERENCE);

    const circleSegments = generateCircleSegments({
        segments,
        centerPoint,
        radius: RADIUS,
        strokeWidth: STROKE_WIDTH,
    });

    const formattedPricingOptionLabel = pricingOptionLabel?.replace(' ', '&nbsp;');

    const priceTextHtml = isFree
        ? `<div class="charger-maker-price-value">FREE</div>`
        : `<div class="charger-maker-price-value">${price}</div>
          <div class="charger-maker-price-desc">${formattedPricingOptionLabel}</div>`;

    const html = `
    <div class="charger-marker-container">
      <div class="charger-marker-circle-container">
        <svg viewBox="0 0 ${SVG_SIZE} ${SVG_SIZE}" width="${SVG_SIZE}" height="${SVG_SIZE}">
          <circle
            cx="${centerPoint}"
            cy="${centerPoint}"
            r="${RADIUS}"
            fill="transparent"
            stroke="#eeeeee"
            stroke-width="${STROKE_WIDTH}"
          ></circle>
          ${circleSegments}
          <text
            x="${centerPoint}"
            y="30"
            font-size="12px"
            text-anchor="middle"
            font-weight="700">
            <tspan><tspan fill="${COLORS.SUCCESS_GREEN}">${availableConnectors}</tspan><tspan fill="#000">/${totalConnectors}</tspan>
            </tspan>
          </text>
        </svg>
      </div>
     <div class="charger-maker-price-container">
        ${priceTextHtml}
     </div>
    <div class="charger-maker-circle-shadow"></div>    
    </div>
  `;

    return html;
}
